"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortResourceConfigurations = void 0;
const lodash_1 = require("lodash");
const sortResourceConfigurations = (resourceConfigurations) => {
    return (0, lodash_1.sortBy)(resourceConfigurations, (resourceConfiguration) => {
        const createdAt = resourceConfiguration.createdAt;
        if (createdAt instanceof Date) {
            return createdAt.getTime();
        }
        return createdAt;
    });
};
exports.sortResourceConfigurations = sortResourceConfigurations;
